const providersMenu: any = {
  id: "users-external-list",
  title: "Fornitori",
  translate: "MENU.EXTERNAL_USERS_LIST",
  type: "item",
  capability: "show_menu_providers",
  url: "dashboard/providers/list",
  icon: "package",
  order: 12,
};
export default providersMenu;
